import type { ReactNode } from "react";
import { cssVar } from "./EChart";
import { IconChevronDown } from "./icons";

// The four 6h IST windows every time-of-day reading in this file is cut on. Shared by the
// stacked sales bars (one segment each) and the inventory line (one background band each),
// so the same hour wears the same colour in both panels. Order is the clock, never size.
export const TOD_BUCKETS = [
  { label: "00-06", token: "--tod-0", fallback: "#4a4c90" },
  { label: "06-12", token: "--tod-1", fallback: "#138db1" },
  { label: "12-18", token: "--tod-2", fallback: "#b18c39" },
  { label: "18-24", token: "--tod-3", fallback: "#98483c" },
] as const;

export const todColors = () => TOD_BUCKETS.map((b) => cssVar(b.token, b.fallback));

// Both charts here are estimates with real caveats, and both used to spend five lines of
// prose saying so under the plot. The lead sentence is the one thing a reader needs; the
// rest is a disclosure, so the caveat is one click away instead of in the way.
export function ChartNotes({ lead, notes }: { lead: ReactNode; notes: ReactNode[] }) {
  return (
    <details className="chart-notes">
      <summary>
        <span>{lead}</span>
        {/* a bordered chip right after the sentence, not a word floated to the far right:
            the affordance has to look pressable and sit where the eye already is */}
        <span className="cn-more">
          {notes.length} caveats
          <IconChevronDown />
        </span>
      </summary>
      <ul>
        {notes.map((n, i) => (
          <li key={i}>{n}</li>
        ))}
      </ul>
    </details>
  );
}

export function money(n: number | null | undefined): string {
  if (n == null || n <= 0) return "\u2014";
  return `\u20b9${Number.isInteger(n) ? n.toFixed(0) : n.toFixed(2)}`;
}

